export const KATANA_CHAIN_ID = 747474
export const HYPER_EVM_CHAIN_ID = 999
export const ETHEREAL_CHAIN_ID = 5064014
export const LIGHTER_CHAIN_ID = 3586256
export const MONAD_CHAIN_ID = 143
export const SOLANA_MAINNET_CHAIN_ID = 1151111081099710
export const HYPERCORE_CHAIN_ID = 1337
export const BITCOIN_MAINNET_CHAIN_ID = 8253038
export const TRON_MAINNET_CHAIN_ID = 728126428
